import { render, staticRenderFns } from "./BuyRate.vue?vue&type=template&id=20def79a&scoped=true"
import script from "./BuyRate.vue?vue&type=script&lang=js"
export * from "./BuyRate.vue?vue&type=script&lang=js"
import style0 from "./BuyRate.vue?vue&type=style&index=0&id=20def79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20def79a",
  null
  
)

export default component.exports